export const formatGraphQLError = (error: any) => error.graphQLErrors[0].message
